import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import SwiperCore, { Pagination } from "swiper";
SwiperCore.use([Pagination]);

const cardData = [
  {
    title: "Secure deposits. Fewer no-shows.",
    subtitle:
      "Collect upfront payments or deposits. Slash no-shows and last-minute cancellations by up to 60% — keep your barbers busy and booked.",
    image: "https://images.pexels.com/photos/3992870/pexels-photo-3992870.jpeg",
  },
  {
    title: "Automated reminders. Fewer gaps.",
    subtitle:
      "Send personalized SMS and email reminders automatically. Confirm more bookings. Keep your chairs filled and clients on time.",
    image: "https://images.pexels.com/photos/3992859/pexels-photo-3992859.jpeg",
  },
  {
    title: "Smart waitlist. Max out your schedule.",
    subtitle:
      "Turn cancellations into fresh appointments. Let clients join your waitlist and auto-fill open slots fast — no wasted time.",
    image: "https://images.pexels.com/photos/2035310/pexels-photo-2035310.jpeg",
  },
  {
    title: "Lock in bookings. Protect your income.",
    subtitle:
      "Secure card details when clients book. Charge for no-shows automatically and keep your revenue protected.",
    image: "https://images.pexels.com/photos/7518735/pexels-photo-7518735.jpeg",
  },
];

const ThirdBarber = () => {
  const [expandedCard, setExpandedCard] = useState(null);

  const toggleExpand = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  return (
    <div className="bg-black py-20 px-4">
      <div className="max-w-7xl mx-auto text-center mb-16">
        <h2 className="text-4xl md:text-5xl font-semibold text-text mb-4">
          No more no-shows. More fresh cuts.
        </h2>
        <p className="text-textGray text-lg max-w-3xl mx-auto">
          Keep your chairs full and your cash flow steady. This is barber shop
          software built to keep your schedule tight and your business growing.
        </p>
      </div>

      <div className="max-w-7xl mx-auto">
        <Swiper
          pagination={{ clickable: true }}
          spaceBetween={30}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1.2 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1280: { slidesPerView: 4 },
          }}
        >
          {cardData.map((card, index) => (
            <SwiperSlide key={index}>
              <div
                className="bg-dry text-text rounded-3xl p-8 h-full flex flex-col justify-between shadow-xl min-h-[500px] cursor-pointer transition-all duration-300"
                onClick={() => toggleExpand(index)}
              >
                <div>
                  <h3 className="text-xl font-semibold whitespace-pre-line mb-4">
                    {card.title}
                  </h3>
                  <p
                    className={`text-sm mb-6 transition-all duration-300 ${
                      expandedCard === index ? "" : "line-clamp-3"
                    }`}
                  >
                    {card.subtitle}
                  </p>
                </div>
                <div className="w-full rounded-xl overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="object-contain mx-auto grayscale"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default ThirdBarber;
